import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from '@reduxjs/toolkit';

import Preview from 'carbon-react/lib/components/preview';

import InviteForm from './InviteForm';
import Translate from '../../components/Translate/Translate';

import { send } from '../../helpers/requests';
import * as user from '../../redux/User/actions';

const Invite = ({ match, registerEmployee }) => {
  const [error, setError] = useState();
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState();

  useEffect(() => {
    validateToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validateToken = async () => {
    try {
      const res = await send({
        url: `/pub/invites/${match.params.inviteToken}`,
        method: 'GET',
      });
      setUser(res);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (user) => {
    registerEmployee(user);
  };

  if (loading)
    return (
      <div className="register">
        <Preview loading height="700px" width="450px" />
      </div>
    );

  if (error)
    return (
      <div className="register" style={{ flexDirection: 'column' }}>
        <p>
          <Translate scope="auth.InviteError" />
        </p>
        <p>{JSON.stringify(error.message)}</p>
      </div>
    );

  return (
    <div className="register">
      <InviteForm onSubmit={handleSubmit} data={user} inviteToken={match.params.inviteToken} />
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  const _user = bindActionCreators(user, dispatch);
  return {
    registerEmployee: _user.registerEmployeeRequest,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Invite));
